import {h, Component} from 'preact';
import PhoneCodeVerification from './phone-code-verification';
import CreatePassword from './create-password';
import PasswordChanged from './password-changed';
import authContainer from '../tags/auth-container';

export class ResetPassword extends Component {
    constructor() {
        super();
        this.state = {
            step: 'phoneCodeVerification',
            password: ''
        }
    }

    componentDidMount() {
        document.title = 'Reset password | workplace_';
        this.props.hideFooter();
    }

    setStep = step => {
        this.setState({ step });
    };

    setPassword = password => {
        this.setState({ password });
    };

    getPassword = () => {
        return this.state.password;
    };

    renderResetPasswordSteps = step => {
        switch (step) {
            case 'phoneCodeVerification':
                return <PhoneCodeVerification setStep={this.setStep}
                                              goToPage={this.props.goToPage}
                                              renderHelpLink={this.props.renderHelpLink}
                />;
            case 'createPassword':
                return <CreatePassword setStep={this.setStep}
                                       setPassword={this.setPassword}
                                       getPassword={this.getPassword}
                                       goToPage={this.props.goToPage}/>;
            case 'passwordChanged':
                return <PasswordChanged getPassword={this.getPassword}
                                        goToPage={this.props.goToPage}/>;
        }
    };

    render({}, {step}) {
        return(
            <section className='auth-modal-container reset-password'>
                {this.renderResetPasswordSteps(step)}
            </section>
        )
    }
}

export default authContainer(ResetPassword);




// WEBPACK FOOTER //
// ./src/scripts/views/reset-password/reset-password.js